import PostHero from './hero';
import PostShort from './short';
import PostVideo from './video';
import PostDefault from './default';

export { PostHero, PostShort, PostVideo, PostDefault };
